import * as React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import FilterRow from './FilterRow';
import Layer from '../data/Layer';
import { Effect } from '@beatflyer/shaders-lib';
import { CompositionEffect } from 'compose/CompositionEffect';

const SortableRow = SortableElement(FilterRow);

interface Props {
  items: (Effect | CompositionEffect)[];
  layer: Layer;
  editableEffect: Effect | null;
  onShowSettings: (
    target: HTMLElement,
    effect: Effect | CompositionEffect
  ) => void;
}

export default class extends React.Component<Props> {
  render() {
    return (
      <div
        className={
          'effects' + (this.props.items.length > 0 ? ' effects--has-some' : '')
        }
      >
        {this.props.items.map((value, index) => {
          const isComposition = value instanceof CompositionEffect;
          return (
            <SortableRow
              value={value}
              layer={this.props.layer}
              key={index}
              index={index}
              isEditing={value === this.props.editableEffect}
              onShowSettings={this.props.onShowSettings}
              disabled={isComposition}
            />
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/FiltersList.tsx